<template>
  <div class="addBank" :class="isScroll?'':'uploadProof'">
    <Header :title="title" :right-content="rightContent" @bankNotice="bankNotice" />
    <div id="content">
      <div class="layout">
        <div class="uploadList">
          <ul>
            <li><span class="check">添加银行卡</span><span class="check">上传证明文件</span><span>提交信息</span></li>
            <li>
              <em />
              <p class="ntn1 check" /><em class="check" /><p class="ntn2 check" /><p />
            </li>
          </ul>
        </div>
        <div class="upload">
          <div class="card">
            <img v-if="isFacade" src="@/assets/images/bank/toolbar_bg1.png">
            <img v-if="isFacadePhoto" preview="0" :src="facadePhoto">
            <input id="face" ref="inputMultiple1" class="inputPhoto" type="file" accept="image/*" value="face" @change="multipleChange(1)">
            <div v-if="facadeMasking" class="masking">
              <div class="item" @click="clickPreview(1)" />
              <img src="@/assets/images/template/toolbar_close1.png" @click="closedelePop(1)">
            </div>
          </div>
          <div class="card">
            <img v-if="isObverse" src="@/assets/images/bank/toolbar_bg2.png">
            <img v-if="isObversePhoto" preview="0" :src="obversePhoto">
            <input id="obverse" ref="inputMultiple2" class="inputPhoto" type="file" accept="image/*" value="obverse" @change="multipleChange(2)">
            <div v-if="obverseMasking" class="masking">
              <div class="item" @click="clickPreview(2)" />
              <img src="@/assets/images/template/toolbar_close1.png" @click="closedelePop(2)">
            </div>
          </div>
        </div>
        <div class="btnItem">
          <span class="submit" :class="isFacadePhoto&&isObversePhoto?'suc':''" @click="submit">提交</span>
          <Chat />
        </div>
      </div>
    </div>
    <!--删除照片-->
    <div v-if="isDelePop" class="popFixed">
      <div class="masking" @click="closedelePop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>请确认要删除此照片</p>
        </div>
        <div class="btnCon">
          <span @click="closedelePop">取消</span>
          <span @click="deleImg">删除</span>
        </div>
      </div>
    </div>
    <!--绑卡须知-->
    <div v-if="bankPop" class="popFixed">
      <div class="masking" @click="noticePop" />
      <div class="tcCon">
        <div class="item">
          <span>绑卡须知</span>
          <p class="txtLeft">填写的银行卡资料将会作为您取款的收款账户。收款账户必须为账户本人所有，银行卡号也须与账户登记时一致。填写完成后，请提供银行卡证明，经验证通过后方可作提款申请用。</p>
        </div>
        <div class="btnCon only">
          <span @click="noticePop">我知道了</span>
        </div>
      </div>
    </div>
    <!--重复提交-->
    <RepeatPop v-if="isRepeatPop" />
    <!--预览图片-->
    <div v-if="isPreviewPop" class="popFixed">
      <div class="masking" @click="closePreview" />
      <img class="preview" :src="previewPic">
    </div>
    <AlertPop
      :model="showAlertPop"
      :content="alertPopContent"
      :button1Txt="'我知道了'"
      @alertOnClose="alertBoxClose"
    />
  </div>
</template>

<script>
require('@/assets/css/addBank.css')
import Header from '@/view/module/Header.vue'
import RepeatPop from '@/view/module/RepeatPop.vue'
import Chat from '@/view/module/Chat.vue'
import AlertPop from '@/view/module/AlertPop.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  name: 'UploadProof',
  components: { Header, RepeatPop, Chat, AlertPop },
  data() {
    return {
      title: '添加银行卡',
      isFacade: true,
      facadePhoto: '',
      facadeFile: '',
      isFacadePhoto: false,
      facadeMasking: false,
      facadeErr: false,
      isObverse: true,
      obversePhoto: '',
      obverseFile: '',
      isObversePhoto: false,
      obverseMasking: false,
      obverseErr: false,
      isDelePop: false,
      closeNum: '',
      bankOrder: this.$route.query.bankOrder || '', // 银行卡序号
      bankPop: false,
      isRepeatPop: false,
      isPreviewPop: false,
      previewPic: '',
      rightContent: 'problem',
      isScroll: '',
      showAlertPop: false,
      alertPopContent: ''
    }
  },
  computed: {
    ...mapState(['pageType', 'token'])
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    hasScrollbar() {
      if (document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    bankNotice(data) {
      this.bankPop = data
    },
    noticePop() {
      this.bankPop = !this.bankPop
    },
    multipleChange(type) {
      let url
      const inputMultiple1 = this.$refs.inputMultiple1
      const inputMultiple2 = this.$refs.inputMultiple2
      if (type == 1) {
        if (inputMultiple1.files) {
          for (const file of inputMultiple1.files) {
            url = URL.createObjectURL(file)
            this.checkPic(file)
            this.compressImg(file, type)
            this.facadePhoto = url
            this.isFacade = false
            this.facadeMasking = true
            this.isFacadePhoto = true
          }
        }
      } else {
        if (inputMultiple2.files) {
          for (const file of inputMultiple2.files) {
            url = URL.createObjectURL(file)
            this.checkPic(file)
            this.compressImg(file, type)
            this.obversePhoto = url
            this.isObverse = false
            this.obverseMasking = true
            this.isObversePhoto = true
          }
        }
      }
      // this.$previewRefresh();
    },
    compressImg(file, type) {
      if (file.size / 1024 > 1025) { // 大于1M，进行压缩上传
        this.photoCompress(file, { quality: 0.2 }, file.name, type)
      } else {
        if (type == 1) {
          this.facadeFile = file
        } else {
          this.obverseFile = file
        }
      }
    },
    photoCompress(file, w, name, type) {
      const ready = new FileReader()
      /* 开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
      ready.readAsDataURL(file)
      const _this = this
      ready.onload = function(e) {
        const path = e.target.result
        _this.canvasDataURL(path, w, name, type)
      }
    },
    canvasDataURL(path, obj, name, type) {
      const _this = this
      const img = new Image()
      img.src = path
      img.onload = function() {
        const that = this
        // 默认按比例压缩
        let w = that.width
        let h = that.height
        const scale = w / h
        w = obj.width || w
        h = obj.height || (w / scale)
        let quality = 0.7 // 默认图片质量为0.7
        // 生成canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        // 创建属性节点
        const anw = document.createAttribute('width')
        anw.nodeValue = w
        const anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(that, 0, 0, w, h)
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality
        }
        // quality值越小，所绘制出的图像越模糊
        const base64 = canvas.toDataURL('image/jpeg', quality)
        // 回调函数返回base64的值
        if (type == 1) {
          _this.facadeFile = _this.dataURLtoFile(base64, name)
        } else {
          _this.obverseFile = _this.dataURLtoFile(base64, name)
        }
      }
    },
    // base64转换为file
    dataURLtoFile(base64, filename) { // 将base64转换为文件
      var arr = base64.split(','); var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1]); var n = bstr.length; var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    closedelePop(type) {
      this.closeNum = type
      this.isDelePop = !this.isDelePop
      if (type == 1) document.getElementById('face').value = null
      else document.getElementById('obverse').value = null
    },
    deleImg() {
      this.isDelePop = !this.isDelePop
      if (this.closeNum == 1) {
        this.isFacade = true
        this.facadeMasking = false
        this.isFacadePhoto = false
        this.facadeFile = ''
      } else {
        this.isObverse = true
        this.obverseMasking = false
        this.isObversePhoto = false
        this.obversePhoto = ''
      }
    },
    checkPic(file) {
      const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      const AllUpExt = '.bmp|.gif|.jpg|.jpeg|.png|.tif|.tiff|'
      if (AllUpExt.indexOf(extName + '|') == '-1') {
        return false
      } else if (file.size > 5242880) {
        return false
      }
      return true
    },
    clickPreview(type) {
      if (type == 1) this.previewPic = this.facadePhoto
      else this.previewPic = this.obversePhoto
      this.isPreviewPop = !this.isPreviewPop
    },
    closePreview() {
      this.isPreviewPop = !this.isPreviewPop
    },
    submit() {
      const fileFormData = new FormData()
      fileFormData.append(`filesBankCardFrontFiles[${this.bankOrder - 1}]`, this.facadeFile)
      fileFormData.append(`filesBankCardBackFiles[${this.bankOrder - 1}]`, this.obverseFile)
      if (this.isFacadePhoto && this.isObversePhoto && this.bankOrder) {
        this.$bus.$emit('loading', false)
        api.uploadCertificate(fileFormData).then(res => {
          if (res.status) {
            if (res.data.code == 200) {
              this.$router.replace({ path: '/home/success' })
            } else if (res.data.code == 1038) {
              this.$bus.$emit('loading', true)
              this.toggleFixed()
              this.isRepeatPop = !this.isRepeatPop
            } else {
              this.$bus.$emit('loading', true)
              this.showAlertPop = true
              this.alertPopContent = res.data.code_desc
            }
          }
        })
      }
    },
    alertBoxClose() {
      this.showAlertPop = false
      this.alertPopContent = ''
    }
  }
}
</script>
